import { render } from "./Article.vue?vue&type=template&id=01f1fbb4&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"

import "./Article.vue?vue&type=style&index=0&id=01f1fbb4&lang=css&scoped=true"
import "./Article.vue?vue&type=style&index=1&id=01f1fbb4&lang=less"
import "./Article.vue?vue&type=style&index=2&id=01f1fbb4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f1fbb4"]])

export default __exports__